/*
 * @Author: Administrator
 * @Date:   2018-08-27 09:38:51
 * @Last Modified by: maoyanping
 * @Last Modified time: 2020-06-19 15:04:59
 */
import Cookies from "js-cookie";
import axios from "axios";
import { Message, MessageBox, Notification, Loading } from "element-ui";
import store from "@/store";

var mainAxios = axios.create();

mainAxios.defaults.timeout = Infinity;
mainAxios.defaults.baseURI = "";

// loading框设置局部刷新，且所有请求完成后关闭loading框
let loading;

function startLoading() {
  loading = Loading.service({
    lock: true,
    text: "Loading...",
    background: "rgba(0, 0, 0, 0.6)",
    target: document.querySelector(".loading-area"),
    // spinner: 'el-icon-loading',
  });
}

function endLoading() {
  loading.close();
}

//声明一个对象用于存储请求个数
let needLoadingRequestCount = 0;

function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading();
  }
  needLoadingRequestCount++;
}

function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    endLoading();
  }
}

//http request 拦截器,表单方式提交x-www-form-urlencoded
mainAxios.interceptors.request.use(
  (config) => {
    // showFullScreenLoading();
    // setTimeout(function(){
    //     tryHideFullScreenLoading()
    // },5000)
    config.data = JSON.stringify(config.data);
    config.headers = {
      "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
    };
    if (Cookies.get("Authorization")) {
      config.headers.Authorization = "Bearer " + Cookies.get("Authorization");
    } else {
      config.headers.Authorization = "Basic dnVlOnZ1ZQ==";
    }
    //loading=Loading.service();
    return config;
  },
  (error) => {
    return Promise.reject(err);
  }
);

//http response 拦截器
mainAxios.interceptors.response.use(
  (response) => {
    // tryHideFullScreenLoading();
    const res = response.data;
    return response.data;
  },
  (error) => {
    // tryHideFullScreenLoading();
    const response = error.response;
    // if (response === undefined) {
    //     Message({
    //         message: '服务请求超时！',
    //         type: 'error',
    //         duration: 10 * 1000
    //     })
    //     return Promise.reject(error)
    // }
    if (response.status === 400 && response.data.error == "invalid_grant") {
      Message({
        message: "账户或密码错误！",
        type: "warning",
      });
      return Promise.reject("error");
    }

    const info = response.data;
    if (response.status === 401 && info.status === 40101) {
      if (location.hash != "#/") {
        MessageBox.confirm(
          "认证过期，可以取消继续留在该页面，或者重新登录",
          "确定退出",
          {
            confirmButtonText: "重新登录",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => {
          // Cookies.remove('Authorization');
          window.location.href = "/";
          // location.reload();
          /*store.dispatch('LogOut').then(() => {
              Cookies.remove('userName');
              location.reload()
            })*/
        });
      }
    }
    if (response.status === 401 && info.status === 40001) {
      Notification.warning({
        title: "禁止",
        message: info.message,
        type: "error",
        duration: 2 * 1000,
      });
      return Promise.reject("error");
    }

    // if (response.status === 500 && info.status === 500) {
    //     Message({
    //         message: '后端服务异常，请联系管理员！',
    //         type: 'error',
    //         duration: 3 * 1000
    //     })
    //     return Promise.reject(error)
    // }

    if (response.status === 403) {
      Notification.warning({
        title: "禁止",
        message: info.message,
        type: "error",
        duration: 2 * 1000,
      });
      return Promise.reject("error");
    }
    if (response.status === 30101) {
      Notification.warning({
        title: "失败",
        message: info.message,
        type: "error",
        duration: 2 * 1000,
      });
      return Promise.reject("error");
    }
    // if (response.status === 504) {
    //     Message({
    //         message: '后端服务异常，请联系管理员！',
    //         type: 'error',
    //         duration: 3 * 1000
    //     })
    //     return Promise.reject(error)
    // }
    /*Message({
      message: info.message,
      type: 'error',
      duration: 5 * 1000
    })*/
    return Promise.reject(error);
  }
);

var parkAxios = axios.create();

parkAxios.defaults.timeout = 10000;
parkAxios.defaults.baseURI = "";

//http request 拦截器
parkAxios.interceptors.request.use(
  (config) => {
    // showFullScreenLoading();
    // setTimeout(function(){
    //     tryHideFullScreenLoading()
    // },5000)

    config.data = JSON.stringify(config.data);
    config.headers = {
      "Content-Type": "application/json;charset=utf-8",
    };

    if (Cookies.get("Authorization")) {
      config.headers.Authorization = "Bearer " + Cookies.get("Authorization");
    } else {
      config.headers.Authorization = "Basic dnVlOnZ1ZQ==";
    }

    // loading=Loading.service();
    return config;
  },
  (error) => {
    return Promise.reject(err);
  }
);

//http response 拦截器
parkAxios.interceptors.response.use(
  (response) => {
    // tryHideFullScreenLoading();
    const res = response.data;

    /*if(response.data.status ==2){
      console.log(this)
        router.push({
          path:"/login",
          querry:{redirect:router.currentRoute.fullPath}//从哪个页面跳转
        })
    }
    // loading.close();
    return response;*/

    // if (response.status !== 200 && res.status !== 200) {
    //     Message({
    //         message: res.message,
    //         type: 'error',
    //         duration: 3 * 1000
    //     })
    // } else
    if (response.status == 200 && res.status == 30101) {
      Notification.error({
        title: "失败",
        message: res.message,
        duration: 2 * 1000,
      });
    } else {
      return response.data;
    }
  },
  (error) => {
    // tryHideFullScreenLoading();
    const response = error.response;
    //  if (response === undefined) {
    //    Message({
    //      message: '服务请求超时！',
    //      type: 'error',
    //      duration: 10 * 1000
    //    })
    //    return Promise.reject(error)
    //  }
    // if (response.status === 400) {
    //     Message({
    //         message: '账户或密码错误！',
    //         type: 'warning'
    //     })
    //     return Promise.reject('error')
    // }

    const info = response.data;
    if (response.status === 401 && info.status === 40101) {
      MessageBox.confirm(
        "你已被登出，可以取消继续留在该页面，或者重新登录",
        "确定登出",
        {
          confirmButtonText: "重新登录",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        Cookies.remove("Authorization");
        window.location.href = "/";
        // location.reload();
        /*store.dispatch('LogOut').then(() => {
          Cookies.remove('userName');
          location.reload()
        })*/
      });
    }

    if (response.status === 401 && info.status === 40001) {
      Notification.warning({
        title: "禁止",
        message: info.message,
        type: "error",
        duration: 2 * 1000,
      });
      return Promise.reject("error");
    }

    // if (response.status === 500 && info.status === 500 && info.message.indexOf('赋值异常') == -1) {
    //     Message({
    //         message: '后端服务异常，请联系管理员！',
    //         type: 'error',
    //         duration: 3 * 1000
    //     })
    //     return Promise.reject(error)
    // } else {
    //     Message({
    //         message: '数值格式不正确,设置失败',
    //         type: 'error',
    //         duration: 3 * 1000
    //     })
    // }

    if (response.status === 403) {
      Notification.warning({
        title: "禁止",
        message: info.message,
        type: "error",
        duration: 2 * 1000,
      });
      return Promise.reject("error");
    }
    if (info.status === 30101) {
      //console.log("66666")
      Message({
        message: info.message,
        type: "error",
        //duration: 3 * 1000
      });
      // Notification.warning({
      //   title: '失败',
      //   message: info.message,
      //   type: 'error',
      //   duration: 2 * 1000
      // })
      return Promise.reject("error");
    }

    // if (response.status === 504) {
    //     Message({
    //         message: '后端服务异常，请联系管理员！',
    //         type: 'error',
    //         duration: 3 * 1000
    //     })
    //     return Promise.reject(error)
    // }
    /*Message({
      message: info.message,
      type: 'error',
      duration: 5 * 1000
    })*/

    return Promise.reject(error);
  }
);

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

/*export function post(url,data = {}){
  return new Promise((resolve,reject) => {
    mainAxios.post(url,data)
         .then(response => {
           resolve(response.data);
         },err => {
           reject(err)
         })
  })
}*/

/* login side */

export const get = (url, params) => {
  return mainAxios({
    method: "get",
    url: `${url}`,
    params: params,
  });
};

export const post = (url, params) => {
  return mainAxios({
    method: "post",
    url: `${url}`,
    data: params,
    responseType: "json",
    transformRequest: [
      function(data) {
        let ret = "";
        var data = JSON.parse(data);
        for (let it in data) {
          ret +=
            encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
        }
        return ret;
      },
    ],
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

/* other */
export const postRequest = (url, params) => {
  return parkAxios({
    method: "post",
    url: `${url}`,
    data: params,
    responseType: "json",
  });
};

export const putRequest = (url, params) => {
  return parkAxios({
    method: "put",
    url: `${url}`,
    data: params,
    responseType: "json",
  });
};

export const deleteRequest = (url, params) => {
  return parkAxios({
    method: "delete",
    url: `${url}`,
    data: params,
  });
};

export const getRequest = (url, params) => {
  return parkAxios({
    method: "get",
    url: `${url}`,
    params: params,
  });
};

//下载文件
const downloadFile = (url, params) => {
  return axios({
    method: "get",
    url: `${url}`,
    params: params,
    responseType: "blob",
    // timeout: 600000,
    headers: {
      Authorization: "Bearer " + Cookies.get("Authorization"),
    },
  });
};

const download = (data, filename) => {
  if (!data) {
    return;
  }
  let url = window.URL.createObjectURL(data);
  let link = document.createElement("a");
  link.style.display = "none";
  link.href = url;
  link.setAttribute("download", `${filename}`);
  document.body.appendChild(link);
  link.click();
};

export function downloadFileRequest(url, data, filename) {
  downloadFile(url, data)
    .then((res) => {
      const disposition = res.headers["content-disposition"];
      if (!disposition) {
        const reader = new FileReader();
        reader.readAsText(res?.data);
        reader.onload = function(event) {
          const result = JSON.parse(event?.target?.result ?? "");
          Notification({
            type: "error",
            title: "失败",
            message: result?.message,
          });
        };
        return;
      }

      Notification({
        type: "success",
        title: "成功",
        message: "下载成功",
      });
      const filenamePostfix = res.headers["content-disposition"]
        .split(";")[1]
        .split("=")[1]
        .split(".")[1];
      download(res.data, `${filename}.${filenamePostfix}`);
    })
    .catch((error) => {
      Notification({
        type: "error",
        title: "失败",
        message: error,
      });
    });
}
